<template>
    <div>
        <div><input type="checkbox" @change="checkAll" class="all-check" />&nbsp;{{ getTranslation('b056') }}</div>
        <Tree :key="selectionVersion" :data="carModelData" :render="renderCarModelContent" class="tree-render" empty-text="">
        </Tree>
    </div>
</template>
<script>

import { mapGetters } from 'vuex'

export default {
    name: 'ExpulsionCarModel', // 组件名称
    components: {
        
    },
    props: {
        carModelData: Array,
    },
    data() {
        return {
            selectionVersion: 1,
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
    },
    watch: {
    },
    created() {
    },
    methods: {
        renderCarModelContent(h, { data }) {
            const labelClick = (e) => {
                e.stopPropagation();
                this.toggleNodeSelection(data);
            };
               let checkboxVNode = h('input', {
                attrs: { type: 'checkbox' },
                domProps: { checked: data.selected },
                style: { marginRight: '0px', cursor: 'pointer' ,border:'1px solid #fff',width:'16px',height:'16px',outline:'none',boxShadow:'none',background:'transparent',padding:'6px 2px',opacity:'1'},                
                on: {
                    change: (e) => this.onNodeCheckboxChange(data, e.target.checked),
                    click: (e) => e.stopPropagation()
                }
            });
            let Label = h('label', {
                style: { display:'inline-block',paddingRight:'8px' },
                attrs: { for: 'cb-p-'+data.id },
                on: {
                    click: (e) => {                        
                        e.stopPropagation()
                    }
                }
            },[checkboxVNode]);

            const titleVNode = h('span', {
                style: { cursor: 'pointer' },
                attrs: { class: 'break-word' },
                on: { click: labelClick }
            }, `${data.name}`);

            return h('span', {
                style: { display: 'inline-block', width: '100%' },
                class: { 'tree-item': true, 'is-selected': data.selected === true },
                on: { click: labelClick } // clicking row toggles too
            }, [
                h('span', { style: { display: 'inline-flex', alignItems: 'top' } }, [
                    Label,
                    titleVNode
                ]),
                h('span', { style: { display: 'inline-block', float: 'right' } }, [

                ])
            ]);
        },
        // toggle selection for a node
        toggleNodeSelection(node) {
            node.selected = !node.selected;
            this.updateSelectedIds();
        },
        // checkbox change handler
        onNodeCheckboxChange(node, val) {
            node.selected = val;
            this.updateSelectedIds();
        },
        updateSelectedIds() {
            this.$emit('updateSelectedCarModelIds', this.carModelData);
        },
        checkAll() {            
            this.allCheck = !this.allCheck;
            this.selectionVersion += 1; // force re-render
            this.carModelData.forEach(item => {
                item.selected = this.allCheck;
            });
            this.updateSelectedIds();
        }

    },
}
</script>
<style>
.break-word {
    overflow: hidden;
    word-wrap: break-word;
    word-break: break-all;
    white-space: normal;
    vertical-align: top;
}
.all-check{
    cursor: pointer;
    border: 1px solid #fff;
    width: 16px;
    height: 16px;
    outline: none;
    box-shadow: none;
    background: transparent;
    padding: 6px 2px;
    opacity: 1;
}
</style>

<style scoped>
@import url("../../../assets/style/list.css");
@import url("../../../assets/style/tab.css");
</style>